import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";

import {
  OverlayTrigger,
  Tabs,
  Tab,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class RawMaterialServiceRequest extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawMaterialsInventory: [],
      rawmaterialservicerequest: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      firstload: false,
    };
  }
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawMaterialsInventory: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialServiceRequest = () => {
    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/GetRawMaterialServiceRequest/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialservicerequest: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialservicerequest: [] }, () => {
      this.GetRawMaterialServiceRequest();
    });
    this.setState({ rawMaterialsInventory: [] }, () => {
      this.GetRawMaterialsInventories();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.GetRawMaterialServiceRequest();
      this.GetRawMaterialsInventories();
    }
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3> Servicing Request &nbsp;</h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div>
            <Tabs
              id="controlled-tab-example"
              activeKey={this.state.key}
              onSelect={(k) => this.setState({ key: k })}
              className="mb-3 bg-light"
              fill
              style={{ fontSize: "16px" }}
            >
              <Tab eventKey="Request" title="1.Request" className="">
                <Table border striped className="px-0 bg-white ">
                  {window.innerWidth > 900 ? (
                    <>
                      <thead className="">
                        <tr className="text-start text-black bg-white border">
                          <th></th>
                          <th width="5%">PmrNo</th>
                          <th width="30%">RawMaterial Name</th>
                          <th width="5%">Price</th>
                          <th width="5%">Qty</th>

                          <th width="10%">Sub.Total</th>
                          <th width="30%">Details</th>
                          <th width="10%">Status</th>
                          <th width="10%" className="text-end">
                            Options
                          </th>
                        </tr>
                      </thead>
                    </>
                  ) : (
                    <></>
                  )}

                  <tbody className="text-primary border">
                    {this.state.rawmaterialservicerequest
                      .filter((f) => f.statusId == 1)
                      .sort((a, b) => (a.created > b.created ? 1 : -1))
                      .map((request, i) =>
                        this.state.reload === true ? (
                          <EditServiceRequestInline
                            index={i}
                            request={request}
                            OnDeleted={this.OnDeleted}
                            Refresh={this.OnRefreshButtonClick}
                            rawMaterialsInventory={
                              this.state.rawMaterialsInventory
                            }
                          ></EditServiceRequestInline>
                        ) : null
                      )}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="Delivered" title="2.Delivered" className="">
                <Table border striped className="px-0 bg-white ">
                  {window.innerWidth > 900 ? (
                    <>
                      <thead className="">
                        <tr className="text-start text-black bg-white border">
                          <th></th>
                          <th width="5%">PmrNo</th>
                          <th width="30%">RawMaterial Name</th>
                          <th width="5%">Price</th>
                          <th width="5%">Qty</th>

                          <th width="10%">Sub.Total</th>
                          <th width="30%">Details</th>
                          <th width="10%">Status</th>
                          <th width="10%" className="text-end">
                            Options
                          </th>
                        </tr>
                      </thead>
                    </>
                  ) : (
                    <></>
                  )}

                  <tbody className="text-primary border">
                    {this.state.rawmaterialservicerequest
                      .filter((f) => f.statusId == 2)
                      .sort((a, b) => (a.created > b.created ? 1 : -1))
                      .map((request, i) =>
                        this.state.reload === true ? (
                          <EditServiceRequestInline
                            index={i}
                            request={request}
                            OnDeleted={this.OnDeleted}
                            Refresh={this.OnRefreshButtonClick}
                            rawMaterialsInventory={
                              this.state.rawMaterialsInventory
                            }
                          ></EditServiceRequestInline>
                        ) : null
                      )}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="OutOfStock" title="3.OutOfStock" className="">
                <Table border striped className="px-0 bg-white ">
                  {window.innerWidth > 900 ? (
                    <>
                      <thead className="">
                        <tr className="text-start text-black bg-white border">
                          <th></th>
                          <th width="5%">PmrNo</th>
                          <th width="30%">RawMaterial Name</th>
                          <th width="5%">Price</th>
                          <th width="5%">Qty</th>

                          <th width="10%">Sub.Total</th>
                          <th width="30%">Details</th>
                          <th width="10%">Status</th>
                          <th width="10%" className="text-end">
                            Options
                          </th>
                        </tr>
                      </thead>
                    </>
                  ) : (
                    <></>
                  )}

                  <tbody className="text-primary border">
                    {this.state.rawmaterialservicerequest
                      .filter((f) => f.statusId == 3)
                      .sort((a, b) => (a.created > b.created ? 1 : -1))
                      .map((request, i) =>
                        this.state.reload === true ? (
                          <EditServiceRequestInline
                            index={i}
                            request={request}
                            OnDeleted={this.OnDeleted}
                            Refresh={this.OnRefreshButtonClick}
                            rawMaterialsInventory={
                              this.state.rawMaterialsInventory
                            }
                          ></EditServiceRequestInline>
                        ) : null
                      )}
                  </tbody>
                </Table>
              </Tab>
            </Tabs>
          </div>
        </div>
      </>
    );
  }
}

export class EditServiceRequestInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      servicerequest: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.servicerequest.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteRawMaterialServiceRequest/" +
        this.state.servicerequest.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This ServiceRequest may be associated with few Products. First disassociate this servicerequest from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ servicerequest: this.props.request });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
    this.props.Refresh();
  };

  render() {
    const req = this.props.request;
    const idx = this.props.index || 0;
    return (
      <>
        {this.state.editModalShow === true ? (
          <ServiceRequestAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            request={this.props.request}
            rawMaterialsInventory={this.props.rawMaterialsInventory}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        {/* DESKTOP ROW (unchanged) */}
        <tr
          className="d-none d-md-table-row text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{idx + 1}</td>
          <td>{req.pmrNo}</td>
          <td>{req.rawMaterialName}</td>
          <td>{req.price}</td>
          <td>{req.qty}</td>
          <td>{req.price * req.qty}</td>
          <td>{req.details}</td>
          <td>
            {req.statusId == 1
              ? "Requested"
              : req.statusId == 2
              ? "Delivered"
              : req.statusId == 3
              ? "OutOfStock"
              : ""}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div className="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="20" />
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>

        {/* MOBILE ROW: 3-column grid */}
        <tr
          className="d-table-row d-md-none text-start bg-white"
          style={{ fontSize: "12px" }}
        >
          <td colSpan="99" style={{ padding: 8 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "8px 12px",
                alignItems: "start",
              }}
              onClick={(e) => {
                // clicking the row opens edit modal (same as desktop row behavior)
                this.OnEditButtonClick && this.OnEditButtonClick(e);
              }}
              role="button"
            >
              {/* Column 1 */}
              <div style={{ gridColumn: "1 / 2" }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>
                  {idx + 1}. {req.rawMaterialName}
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>PmrNo</div>
                  <div>{req.pmrNo}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Price</div>
                  <div>{req.price}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Qty</div>
                  <div>{req.qty}</div>
                </div>
              </div>

              {/* Column 2 */}
              <div style={{ gridColumn: "2 / 3" }}>
                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Sub.Total</div>
                  <div>{req.price * req.qty}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Details</div>
                  <div>{req.details}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Status</div>
                  <div>
                    {req.statusId == 1
                      ? "Requested"
                      : req.statusId == 2
                      ? "Delivered"
                      : req.statusId == 3
                      ? "OutOfStock"
                      : ""}
                  </div>
                </div>
              </div>

              {/* Column 3 */}
              <div style={{ gridColumn: "3 / 4" }}>
                {/* Actions */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                  }}
                >
                  <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                    <Button
                      size="sm"
                      className="rounded-circle p-1"
                      variant="warning"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.OnEditButtonClick(e);
                      }}
                    >
                      <BsFillPencilFill size="14" />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
                    <Button
                      size="sm"
                      className="rounded-circle p-1"
                      variant="danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          window.confirm("Are you sure you want to delete?")
                        ) {
                          this.OnDelete();
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path
                          fillRule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class ServiceRequestAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      statusId: this.props.request.statusId,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  UpdateRawMaterialsServiceRequest = () => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // body: JSON.stringify(tmpServiceRequest),
    };

    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/UpdateRawMaterialsServiceRequest/" +
        this.props.request.id +
        "/" +
        this.state.statusId,
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This ServiceRequest is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.UpdateRawMaterialsServiceRequest();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "statusId":
        this.setState({ statusId: value });
        break;
    }
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ servicerequest: this.props.servicerequest });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="ServiceRequestModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Service Request"
                  : "Add Service Request"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <h4>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        PMR No:
                      </Form.Label>
                      <Col sm="9">{this.props.request.pmrNo}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        RawMaterial Name:
                      </Form.Label>
                      <Col sm="9">
                        {
                          // this.props.rawMaterialsInventory?.filter(
                          //   (f) => f.id == this.props.request.rawMaterialId
                          // )[0].name
                          this.props.request.rawMaterialName
                        }
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Price:
                      </Form.Label>
                      <Col sm="9">{this.props.request.price}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Qty:
                      </Form.Label>
                      <Col sm="9">{this.props.request.qty}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Sub.Total:
                      </Form.Label>
                      <Col sm="9">
                        {this.props.request.price * this.props.request.qty}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Details:
                      </Form.Label>
                      <Col sm="9">{this.props.request.details}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Details:
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="statusId"
                          required
                          value={this.state.statusId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value="1">Requested</option>
                          <option value="2">Delivered</option>
                          <option value="3">OutOfStock</option>
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </h4>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
